// extracted by mini-css-extract-plugin
var _1 = "bus-DfI2";
var _2 = "busBg-q2cv";
var _3 = "#007ac9";
var _4 = "#575757";
var _5 = "1.5rem";
var _6 = "ferry-hUQZ";
var _7 = "ferryBg-O2jy";
var _8 = "#dedede";
var _9 = "#adf";
var _a = "1rem";
var _b = "#bebebe";
var _c = "notFound-S569";
var _d = ".8rem";
var _e = "subway-XVMb";
var _f = "subwayBg-0wbS";
var _10 = "train-VppS";
var _11 = "trainBg-rjKX";
var _12 = "tram-vr8k";
var _13 = "tramBg-yIIN";
var _14 = "#000";
export { _1 as "bus", _2 as "busBg", _3 as "busBlue", _4 as "darkGrey", _5 as "extraLargeFontSize", _6 as "ferry", _7 as "ferryBg", _8 as "lightGrey", _9 as "lightblue", _a as "mediumFontSize", _b as "mediumLightGrey", _c as "notFound", _d as "smallFontSize", _e as "subway", _f as "subwayBg", _10 as "train", _11 as "trainBg", _12 as "tram", _13 as "tramBg", _14 as "unusedNodeColor" }
